module.exports = __webpack_public_path__ + "static/media/IMG_6594.93dea67f.jpg";